export default {
      id: "common__zoom-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__zoom",
      toString: function () {
        return this.url;
      }
    }